import React from 'react';
import { useEffect, Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, Link } from "react-router-dom"
import { resetAnomalyChartData, resetAnomalyTable } from '../anomalyRegistration/anomalySlice';
import { Container, Stack, Form, Col, Row, Button, FloatingLabel, ToggleButton, Card } from "react-bootstrap";
import { AnomalyTable } from './anomalyTable';
import { ViewChart } from './viewChart';
import { setPageName } from '../login/loginSlice';


export function AnomalyReport() {

    const log = useSelector((state) => state.login)
    const anomaly = useSelector((state) => state.anomaly)
    const dispatch = useDispatch()
    let navigate = useNavigate();
    useEffect(() => {
        if (!log.token) {
            return navigate("/login");
        }else{
            dispatch(setPageName("Отчеты по аномалиям"))
        }
    })
    function onReset() {
        dispatch(resetAnomalyChartData())
        dispatch(resetAnomalyTable())
    }

    return (

            <Stack gap={3} className="col-xl-5 col-lg-6 mx-auto vstack gap-3">
                <ViewChart />
                <AnomalyTable />
                <div className="d-grid">
                <Button variant="primary" as={Link} to="/db" >База</Button>
                    </div>
            </Stack>

    )
}
